import { Component, Input } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';

interface encabezado {
  directorio: string
  nombre: string
  extension: string
}


@Component({
  selector: 'app-encabezado',
  templateUrl: './encabezado.component.html',
  styleUrls: ['./encabezado.component.css']
})
export class EncabezadoComponent {
  @Input() title:string = '*Colocar el titulo*'
  titulo:encabezado = this.getTitulo()

  constructor(private router:ActivatedRoute, private location :Location){
  }

  getTitulo():encabezado{
    const ruta = this.location.path();
    const segmentos = ruta.split('/');
    const ordenado = {
      directorio:segmentos[1],
      nombre: segmentos[2],
      extension: segmentos.length > 3 ? segmentos[3].split('?')[0].split("_").join(' ') : segmentos[3].split("_").join(' '),
    };
    return ordenado
  }

}
